<template>
  <div>
    <hero></hero>
    <SpaceAndroid></SpaceAndroid>
  </div>
</template>
<script>
import SpaceAndroid from "./components/aldtek/examples/SpaceAndroid.vue";

import Hero from "./components/Hero";

export default {
  name: "Home",
  components: {
    Hero,
    SpaceAndroid
  }
};
</script>
